import { CheckoutStepsEnum } from '@seb/web-design-system/checkout';

export interface CheckoutStep {
  enum: CheckoutStepsEnum;
  url: string;
  translationKey: string;
  visible?: boolean;
  additionalUrls?: string[];
}

export const CHECKOUT_STEPS: CheckoutStep[] = [
  { enum: CheckoutStepsEnum.overview, url: '/cart', translationKey: 'checkout.steps.firstStep', visible: true },
  { enum: CheckoutStepsEnum.shipping, url: '/checkout/multi/choose-delivery', translationKey: 'checkout.steps.secondStep', visible: true },
  { enum: CheckoutStepsEnum.payments, url: '/checkout/multi/choose-payment-method', translationKey: 'checkout.steps.thirdStep', visible: true },
  { enum: CheckoutStepsEnum.donations, url: '/donations', translationKey: 'checkout.steps.fourthStep' },
  { enum: CheckoutStepsEnum.recap, url: '/order-confirmation', translationKey: 'checkout.steps.fourthStep', additionalUrls: [
    '/received-order-confirmation', '/checkout/express/review'
  ] }
];
